export function getdata(){
	var obj = {
			headData: [{
				title: "城镇土地使用税",
				children: [{
					title: "序号",
					prop: "groud",
					custom: true,
				}, {
					title: "土地编号",
					prop: "ccxwtd_1_x_1",
					custom: true,
					
				}, {
					title: "税款所属期起",
					prop: "ccxwtd_1_x_2",
					custom: true,
					

				}, {
					title: "税款所属期止",
					prop: "ccxwtd_1_x_3",
					custom: true,
					

				}, {
					title: "减免性质代码和项目名称",
					prop: "ccxwtd_1_x_4",
					custom: true,
					

				}, {
					title: "减免税额",
					prop: "ccxwtd_1_x_5",
					custom: true,
				}]
			}],
			tableData: [{
				groud: 1,
				disabledccxwtd_1_x_1: false,
				disabledccxwtd_1_x_2: false,
				disabledccxwtd_1_x_3: false,
				disabledccxwtd_1_x_4: false,
				disabledccxwtd_1_x_5: false,
				ccxwtd_1_x_1: {
					cellCode: "ccxwtd_1_a1_1",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwtd_1_x_2: {
					cellCode: "ccxwtd_1_a1_2",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwtd_1_x_3: {
					cellCode: "ccxwtd_1_a1_3",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwtd_1_x_4: {
					cellCode: "ccxwtd_1_a1_4",
					cellType: "1",
					cellVal: "240040043.08"
				},
				ccxwtd_1_x_5: {
					cellCode: "ccxwtd_1_a1_5",
					cellType: "1",
					cellVal: "240040043.08"
				},
		
				},
				{
					groud: 2,
					disabledccxwtd_1_x_1: false,
					disabledccxwtd_1_x_2: false,
					disabledccxwtd_1_x_3: false,
					disabledccxwtd_1_x_4: false,
					disabledccxwtd_1_x_5: false,
					ccxwtd_1_x_1: {
						cellCode: "ccxwtd_1_a2_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_2: {
						cellCode: "ccxwtd_1_a2_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_3: {
						cellCode: "ccxwtd_1_a2_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_4: {
						cellCode: "ccxwtd_1_a2_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_5: {
						cellCode: "ccxwtd_1_a2_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
				},
				{
					groud: '小计',
					disabledccxwtd_1_x_1: false,
					disabledccxwtd_1_x_2: false,
					disabledccxwtd_1_x_3: false,
					disabledccxwtd_1_x_4: false,
					disabledccxwtd_1_x_5: false,
					ccxwtd_1_x_1: {
						cellCode: "ccxwtd_1_a3_1",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_2: {
						cellCode: "ccxwtd_1_a3_2",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_3: {
						cellCode: "ccxwtd_1_a3_3",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_4: {
						cellCode: "ccxwtd_1_a3_4",
						cellType: "1",
						cellVal: "240040043.08"
					},
					ccxwtd_1_x_5: {
						cellCode: "ccxwtd_1_a3_5",
						cellType: "1",
						cellVal: "240040043.08"
					},
			}],
	}
	return obj
}
